<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @ok="duplicateUnitGroup"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >
            <template #modal-title>
                Duplicate Unit
            </template>

            <div v-if="loading_publications" class="mb-3">
                <b-spinner label="Loading..."></b-spinner>
            </div>
            <div v-else>
                <b-form-group
                    label="Publication"
                    label-for="target_publication"
                >
                    <multiselect
                        v-model="target_publication"
                        :options="filtered_publications"
                        :class="{'is-invalid': validating && !target_publication}"
                        :custom-label="formatPublicationLabel"
                        label="title"
                        track-by="title"
                    />

                    <b-form-text>
                        Select the Publication you would like to duplicate this Unit into
                    </b-form-text>

                    <b-form-invalid-feedback :state="validating && !target_publication ? false : null">
                        Publication is required
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>

            <template #modal-footer>
                <b-button
                    variant="light"
                    @click="cancel"
                >
                    Cancel
                </b-button>
                <b-button
                    variant="info"
                    @click="duplicateUnitGroup"
                >
                    <font-awesome-icon :icon="['fad', 'clone']" fixed-width/>
                    Duplicate Unit
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import {mapState} from 'vuex'

export default {
    data: () => ({
        target_publication: null,
        loading_publications: false,
    }),
    props: [
        'value',
    ],
    components: {},
    computed: {
        ...mapState({
            validating: state => state.utilities.validating,
            publications: state => state.publications.publications,
            publication: state => state.publications.publication[0],
        }),
        modal_id() {
            let modal_id = 'duplicate-unit-group-modal'
            return modal_id
        },
        filtered_publications() {
            return this.publications.filter((publication) => {
                const notCurrentPublication = publication.id !== this.publication.id
                const notLockedPublication = publication.locked === false

                return notCurrentPublication && notLockedPublication
            });
        }
    },
    watch: {
        value: {
            handler(value) {
                if (value == true) {
                    this.$store.commit('setValidating', false)

                    this.getPublications()
                }
            }
        }
    },
    methods: {
        formatPublicationLabel(publication) {
            return `${publication.title || 'no title'} (${publication.sku})`
        },
        getPublications() {
            this.loading_publications = true

            this.$store.dispatch('getPublications')
                .then(() => {
                    this.loading_publications = false
                })
        },
        duplicateUnitGroup() {
            this.$store.commit('setValidating', true)

            if (!this.validated()) {
                return false
            }

            this.$emit('duplicate', this.target_publication)
        },
        validated() {
            let validated = true

            if (!this.target_publication) {
                validated = false
            }

            return validated
        },
        cancel(event) {
            event.preventDefault()

            this.hide()
        },
        hide() {
            this.$emit('hide')
        },
        hidden() {
            this.target_publication = null

            this.$emit('hide')
        }
    }
}
</script>
